import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Grid, makeStyles, Typography, Divider, Chip } from "@material-ui/core";
import { DataTable, Button, Can, SubmitButton, StaffDrawerShift, CreatableSelectSM, StaffDrawerChat } from "../../../../";
import EmailIcon from "@material-ui/icons/Email";
import * as Yup from "yup";
import { Formik, Form, Field, FieldArray } from "formik";
import { TextField } from "formik-material-ui";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import RemoveRedEye from "@material-ui/icons/RemoveRedEye";
var useStyles = makeStyles(function (theme) {
  return {
    box: {
      display: "flex",
      "align-items": "center",
      "border-radius": "4px",
      border: "1px solid #7d7d7d"
    },
    titleCard: {
      textAlign: "center",
      width: "100%",
      margin: "16px 0"
    },
    actionsTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    mt50: {
      marginTop: "50px"
    },
    chip: {
      borderRadius: "5px",
      border: "1px solid #999",
      color: "#fff",
      background: "transparent",
      margin: "8px"
    },
    title: {
      margin: "16px 0 8px 0"
    },
    card: {
      padding: "8px",
      borderRadius: "5px",
      border: "1px solid #999",
      color: "#fff",
      background: "transparent"
    },
    cardText: {
      marginTop: "8px"
    },
    cardIconText: {
      marginTop: "8px",
      display: "flex",
      alignItems: "center"
    },
    actions: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: "24px"
    },
    mr30: {
      marginRight: "30px"
    },
    icon: {
      margin: "8px"
    },
    mt8: {
      marginTop: "8px"
    },
    divider: {
      margin: "4px 0"
    },
    containerDelete: {
      height: "100vh",
      display: "flex",
      alignItems: "center"
    },
    alignCenter: {
      width: "100%",
      textAlign: "center"
    },
    iconDelete: {
      fontSize: "128px",
      textAlign: "center",
      width: "100%"
    },
    iconStaff: {
      fontSize: "80px",
      textAlign: "center",
      width: "100%"
    },
    iconActions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    certificate: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    certificateLink: {
      textDecoration: "none",
      color: "inherit"
    },
    text: {
      fontFamily: theme.typography.fontFamily
    }
  };
});

var WebStaffSingle = function WebStaffSingle(props) {
  var classes = useStyles();

  var _useState = useState("view"),
      _useState2 = _slicedToArray(_useState, 2),
      type = _useState2[0],
      setType = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      drawerShiftOpen = _useState4[0],
      setDrawerShiftOpen = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      drawerChatOpen = _useState6[0],
      setDrawerChatOpen = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      shiftSelected = _useState8[0],
      setShiftSelected = _useState8[1];

  var toggleShiftDrawer = function toggleShiftDrawer() {
    setDrawerShiftOpen(!drawerShiftOpen);
  };

  var toggleChatDrawer = function toggleChatDrawer() {
    setDrawerChatOpen(!drawerChatOpen);
  };

  var renderStaffContent = function renderStaffContent() {
    var content;

    switch (type) {
      case "view":
        content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h5",
          align: "center"
        }, props.data && props.data.staff && props.data.staff.name)), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(AccountCircleIcon, {
          className: classes.iconStaff
        })), /*#__PURE__*/React.createElement(Can, {
          role: props.role,
          perform: "staff:edit_staff",
          yes: function yes() {
            return /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.iconActions
            }, /*#__PURE__*/React.createElement(EditIcon, {
              style: {
                color: "#ffe082"
              },
              className: classes.icon,
              onClick: function onClick() {
                setType("edit");
              }
            }));
          },
          no: function no() {
            return null;
          }
        }), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          align: "center"
        }, props.data && props.data.staff && props.data.staff.role && props.translation ? props.translation.roles ? props.translation.roles[props.data.staff.role] || "" : "" : "")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.title
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h6"
        }, props.translation ? props.translation.personal_info || "Personal Info" : "Personal Info"), /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, "".concat(props.translation ? props.translation.email || "Email: " : "Email:", " ").concat(props.data && props.data.staff ? props.data.staff.email : "")), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, "".concat(props.translation ? props.translation.phone || "Telephone: " : "Telephone:", " ").concat(props.data && props.data.staff ? props.data.staff.phone : "")), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, "".concat(props.translation ? props.translation.ssn || "SSN: " : "SSN:", " ").concat(props.data && props.data.staff ? props.data.staff.ssn : "")), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, "".concat(props.translation ? props.translation.bank_account_number || "Bank account number: " : "Bank account number:", " ").concat(props.data && props.data.staff ? props.data.staff.bankAccountNumber : "")), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, "".concat(props.translation ? props.translation.identification_number || "Identification Number: " : "Identification Number:", " ").concat(props.data && props.data.staff ? props.data.staff.identificationNumber : ""))), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.title
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h6"
        }, props.translation ? props.translation.services || "Services" : "Services"), /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, props.data && props.data.staff && props.data.staff.services && props.data.staff.services.map(function (service) {
          return /*#__PURE__*/React.createElement(Chip, {
            key: "staff-drawer-staff-service-".concat(service._id),
            label: service.id && service.id.name,
            className: classes.chip
          });
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.title
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h6"
        }, props.translation ? props.translation.sports || "Sports" : "Sports"), /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, props.data && props.data.staff && props.data.staff.sports && props.data.staff.sports.canTeach && props.data.staff.sports.canTeach.map(function (sport, index) {
          return /*#__PURE__*/React.createElement(Chip, {
            key: "staff-drawer-staff-sport-".concat(index),
            label: sport,
            className: classes.chip
          });
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.title
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h6"
        }, props.translation ? props.translation.certificates || "Certificates" : "Certificates"), /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, props.data && props.data.staff && props.data.staff.certificates && props.data.staff.certificates.map(function (certificate, index) {
          return /*#__PURE__*/React.createElement("div", {
            className: classes.certificate
          }, /*#__PURE__*/React.createElement("span", {
            className: [classes.text, classes.mr30].join(" ")
          }, certificate.name), /*#__PURE__*/React.createElement(RemoveRedEye, {
            fontSize: "small",
            onClick: function onClick() {
              props.data.handleViewCertificate(certificate.fileRoute).then(function (link) {
                console.log("link", link);
                window.open(link, "_blank");
              });
            }
          }));
        })));
        break;

      case "edit":
        var initialValues = {
          name: "",
          phone: "",
          identificationNumber: "",
          ssn: "",
          bankAccountNumber: "",
          sports: {
            canTeach: [],
            likes: []
          }
        };
        var staffSchema = Yup.object().shape({
          name: Yup.string().required("Campo obligatorio"),
          phone: Yup.string().required("Campo obligatorio"),
          identificationNumber: Yup.string().required("Campo obligatorio"),
          ssn: Yup.string().required("Campo obligatorio"),
          bankAccountNumber: Yup.string().required("Campo obligatorio"),
          sports: Yup.object().shape({
            canTeach: Yup.array(),
            likes: Yup.array()
          })
        });

        var staff = _objectSpread({}, props.data.staff);

        content = /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Formik, {
          initialValues: staff || initialValues,
          validationSchema: staffSchema,
          onSubmit: function onSubmit(values) {
            var finalValues = {
              name: values.name,
              phone: values.phone,
              identificationNumber: values.identificationNumber,
              ssn: values.ssn,
              bankAccountNumber: values.bankAccountNumber,
              sports: values.sports
            };
            finalValues.nameChanged = false;

            if (props.data.staff.name !== values.name) {
              finalValues.nameChanged = true;
            }

            props.data.handleEditStaff(finalValues);
            setType("view");
          },
          render: function render(_ref) {
            var values = _ref.values,
                isValid = _ref.isValid,
                isSubmitting = _ref.isSubmitting;
            return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
              container: true,
              spacing: 2
            }, /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.name || "Name" : "Name" : "Name",
              name: "name",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.phone || "Phone" : "Phone" : "Phone",
              name: "phone",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.identification_number || "Identification Number" : "Identification Number" : "  Identification Number",
              name: "identificationNumber",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.ssn || "SSN" : "SSN" : "SSN",
              name: "ssn",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(Field, {
              component: TextField,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.bank_account_number || "Bank Account Number" : "Bank Account Number" : "Bank Account Number",
              name: "bankAccountNumber",
              variant: "outlined",
              fullWidth: true,
              margin: "normal"
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(Field, {
              component: CreatableSelectSM,
              label: props.translation ? props.translation.inputs ? props.translation.inputs.sports || "Sports" : "Sports" : "Sports",
              options: values.sports ? values.sports.canTeach ? values.sports.canTeach.map(function (sport) {
                return {
                  label: sport,
                  value: sport
                };
              }) : [] : [],
              name: "sports.canTeach",
              variant: "outlined",
              fullWidth: true,
              margin: "normal",
              isMulti: true
            }))), /*#__PURE__*/React.createElement(Grid, {
              container: true,
              className: classes.actions
            }, /*#__PURE__*/React.createElement(Button, {
              type: "button",
              size: "medium",
              className: classes.mr30,
              color: "secondary",
              variant: "outlined",
              onClick: function onClick() {
                setType("view");
              }
            }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
              size: "medium",
              color: "primary",
              variant: "outlined",
              disabled: !isValid || isSubmitting,
              component: SubmitButton,
              type: "submit"
            }, props.translation ? props.translation.buttons ? props.translation.buttons.edit || "Edit" : "Edit" : "Edit")));
          }
        }));
        break;

      case "delete":
        content = /*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.containerDelete,
          alignItems: "center",
          spacing: 2
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(HighlightOffIcon, {
          color: "secondary",
          className: classes.iconDelete
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "h6",
          className: classes.alignCenter
        }, props.translation ? props.translation.texts ? props.translation.texts.delete_staff ? "".concat(props.translation.texts.delete_staff.title) || "Delete staff" : "Delete staff" : "Delete staff" : "Delete staff"), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          className: classes.alignCenter
        }, props.translation ? props.translation.texts ? props.translation.texts.delete_staff ? props.translation.texts.delete_staff.text ? props.translation.texts.delete_staff.text || "Do you want to delete?" : "Do you want to delete?" : "Do you want to delete?" : "Do you want to delete?" : "Do you want to delete?")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Button, {
          fullWidth: true,
          variant: "contained",
          color: "default",
          onClick: function onClick() {
            setType("view");
          }
        }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Button, {
          fullWidth: true,
          variant: "contained",
          color: "secondary",
          onClick: function onClick() {
            props.data.handleDeleteStaff();
          }
        }, props.translation ? props.translation.buttons ? props.translation.buttons["delete"] || "Delete" : "Delete" : "Delete")));
        break;

      default:
        content = "";
        break;
    }

    return content;
  };

  var handleSelectShift = function handleSelectShift(id) {
    setShiftSelected(props.data.shifts.find(function (shift) {
      return shift._id === id;
    }));
    toggleShiftDrawer();
  };

  var auxTranslation = props.translation;

  if (auxTranslation && auxTranslation.datatables && auxTranslation.datatables.shifts) {
    !auxTranslation.datatables.shifts.columns.find(function (column) {
      return column.name === "options";
    }) ? auxTranslation.datatables.shifts.columns.push({
      label: "",
      name: "options",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        empty: true,
        label: false,
        customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
          return /*#__PURE__*/React.createElement(VisibilityIcon, {
            onClick: function onClick() {
              return handleSelectShift(tableMeta.rowData[0]);
            }
          });
        }
      }
    }) : auxTranslation.datatables.shifts.columns[auxTranslation.datatables.shifts.columns.length - 1] = {
      label: "",
      name: "options",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        empty: true,
        label: false,
        customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
          return /*#__PURE__*/React.createElement(VisibilityIcon, {
            onClick: function onClick() {
              return handleSelectShift(tableMeta.rowData[0]);
            }
          });
        }
      }
    };
  }

  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(StaffDrawerShift, {
    open: drawerShiftOpen,
    data: shiftSelected,
    toggleDrawer: toggleShiftDrawer,
    mapboxApiAccessToken: props.mapboxApiAccessToken,
    translation: props.translation ? props.translation.drawers ? props.translation.drawers.shifts || null : null : null
  }), /*#__PURE__*/React.createElement(StaffDrawerChat, {
    open: drawerChatOpen,
    name: props.data ? props.data.staff ? props.data.staff.name || "" : "" : "",
    room: props.data ? props.data.staff ? props.data.staff.rocket_chat ? props.data.staff.rocket_chat.username || "" : "" : "" : "",
    toggleDrawer: toggleChatDrawer,
    auth_token: props.auth_token,
    chatServer: props.chatServer
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, renderStaffContent()), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 10
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, props.translation ? props.translation.title : "Shifts")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 2,
    className: classes.actionsTitle
  }, /*#__PURE__*/React.createElement(EmailIcon, {
    color: "primary",
    onClick: toggleChatDrawer
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 11,
    className: classes.mt50
  }, /*#__PURE__*/React.createElement(DataTable, {
    data: props.data ? props.data.shifts || [] : [],
    translation: auxTranslation ? auxTranslation.datatables ? auxTranslation.datatables.shifts || null : null : null
  }))));
};

// DRAWER STAFF
//  ROOM USERNAME ROCKET USUARIO
//  TYPE DIRECT
export { WebStaffSingle };